import { bind } from "@react-rxjs/core";
import { createSignal } from "@react-rxjs/utils";
import { IOrderSetEmployeeModel, IOrderSetParametersModel } from "api/OrderApi/interfaces-model";
import { map } from "rxjs/operators";
import { OrderDeliveryStatus } from "utils/enums";

export const [orderClick$, setOrderId] = createSignal<number>();
export const [useOrderId, orderId$] = bind(
  orderClick$.pipe(
    map((value) => {
      return value;
    })
  ),
  0
);

export const [orderEmployee$, setOrderEmployee] =
  createSignal<IOrderSetEmployeeModel>();
export const [useOrderEmplyeeChanged, orderEmployeeChanged$] = bind(
  orderEmployee$.pipe(
    map((value) => {
      return value;
    })
  ),
  {
    orderId: 0,
    employeeId: 0,
  }
);

export const [orderParameters$, setOrderParameters] =
  createSignal<IOrderSetParametersModel>();
export const [useOrderParametersChanged, orderParametersChanged$] = bind(
  orderParameters$.pipe(
    map((value) => {
      return value;
    })
  ),
  {
    orderId: 0,
    deliveryStatus: OrderDeliveryStatus.New,
    isOnTimeDelivery: false,
    readyDate: "",
  }
);
